module.exports = __webpack_public_path__ + "static/img/ruzhu_top_bg_url.c384b7db.png";